import React, { useState } from "react";
import { GridProducts } from "../GridProducts";
import CategorySlider from "../CategorySlider";
import GridFilters from "../GridFilters";
import {
  Box,
  Button,
  Grid,
  Paper,
  Tooltip,
  Typography,
  Drawer,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { COLORS } from "../../constants";

const MobileProductGrid = ({
  products,
  pricingData,
  stockInfo,
  customerCategory,
  categoriesAndTypes,
  activeVendor,
  activeFilters,
  pageNumber,
  pageSize,
  total,
  handlePageNumberChange,
  updateQueryParameters,
  vendorOptions,
  makeOptions,
  modelOptions,
  variantOptions,
  yearOptions,
  productCategoriesListToUse,
  productTypesListToUse,
  showAllCategories,
  showAllTypes,
  showMoreCategories,
  showLessCategories,
  showMoreTypes,
  showLessTypes,
  handleFilterChange,
  changePageCategory,
  changePageProductType,
  clearPageProductType,
  handleActiveCategoryChange,
  isMobile,
  filtersLoading,
}) => {
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);

  const toggleFilterDrawer = () => {
    setFilterDrawerOpen(!filterDrawerOpen);
  };

  return (
    <Box sx={{ py: 2, minHeight: "54vh" }}>
      {total === 0 ? (
        <Grid
          container
          spacing={2}
          sx={{ verticalAlign: "middle", alignContent: "center", p: 10 }}
        >
          <Grid item xs={12}>
            <Typography variant="body2" align="center">
              No products matching your criteria.
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="error"
              onClick={() => window.history.back()}
              size="small"
            >
              Try again
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          {/* <Grid item xs={12} sx={{ marginTop: "32px", marginBottom: "32px" }}>
            {categoriesAndTypes && (
              <CategorySlider
                categoriesAndTypes={categoriesAndTypes}
                handleActiveCategoryChange={handleActiveCategoryChange}
              />
            )}
          </Grid> */}
          <Grid item xs={12}>
            {activeVendor && (
              <Grid container spacing={2} sx={{ marginBottom: "32px" }}>
                <Grid item xs={12} md={4}>
                  <Box
                    sx={{
                      padding: 4,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <Tooltip
                      title={activeVendor.description}
                      arrow
                      placement="top"
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          width: "100%",
                          padding: "8px",
                        }}
                      >
                        <img
                          src={activeVendor.image}
                          alt={activeVendor.name}
                          style={{ maxHeight: "100%", maxWidth: "100%" }}
                        />
                      </Box>
                    </Tooltip>
                  </Box>
                </Grid>
                {activeVendor?.description && (
                  <Grid item xs={12} md={8}>
                    <Box
                      sx={{
                        padding: 4,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        component="p"
                      >
                        {activeVendor.description}
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            )}
          </Grid>

          <Grid item xs={12} md={9}>
            <GridProducts
              products={products}
              pricingData={pricingData}
              stockInfo={stockInfo}
              customerCategory={customerCategory}
              pageNumber={pageNumber}
              handlePageNumberChange={handlePageNumberChange}
              totalResults={total}
              pageSize={pageSize}
              toggleFilterDrawer={toggleFilterDrawer}
              itemsPerRow={isMobile ? 2 : 3}
            />
          </Grid>
        </Grid>
      )}
      {/* Filter Drawer */}
      <Drawer
        anchor="left"
        open={filterDrawerOpen}
        onClose={toggleFilterDrawer}
        sx={{
          width: "75%",
          "& .MuiDrawer-paper": {
            width: "75%",
            height: "100vh",
            boxSizing: "border-box",
            backgroundColor: COLORS.background,
          },
        }}
      >
        <Box sx={{ px: 1 }}>
          <IconButton
            onClick={toggleFilterDrawer}
            sx={{ mt: 1, ml: "auto", display: "block" }}
          >
            <CloseIcon
              sx={{
                color: COLORS.themeBlack,
              }}
            />
          </IconButton>
          <GridFilters
            activeFilters={activeFilters}
            showAllCategories={showAllCategories}
            showAllTypes={showAllTypes}
            changePageCategory={changePageCategory}
            changePageProductType={changePageProductType}
            clearPageProductType={clearPageProductType}
            makeOptions={makeOptions}
            handleFilterChange={handleFilterChange}
            productCategoriesListToUse={productCategoriesListToUse}
            variantOptions={variantOptions}
            yearOptions={yearOptions}
            showMoreCategories={showMoreCategories}
            showLessCategories={showLessCategories}
            modelOptions={modelOptions}
            vendorOptions={vendorOptions}
            productTypesListToUse={productTypesListToUse}
            showMoreTypes={showMoreTypes}
            showLessTypes={showLessTypes}
            filtersLoading={filtersLoading}
          />
        </Box>
      </Drawer>
    </Box>
  );
};

export default MobileProductGrid;
